<template>
  <div>
    <Loading :visible="isLoadingPop"></Loading>
    <div class="wrap password-trans-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>비밀번호 변경</h3>
      </div>
      <div class="body-wrap">
        <h4 v-if="isAccountText == 1" class="mb-20">
          계정이 확인되었습니다.<br />
          비밀번호를 재설정하여 재로그인 해주세요.<br />
          비밀번호는 영문+숫자+특수문자 (8자 이상) 입력해 주세요.
        </h4>
        <ul>
          <!-- <h4 class="bold">현재 비밀번호</h4> -->
          <!-- <li>
                        <input type="password" placeholder="현재 비밀번호를 입력하세요" v-model="input.currentPassword" @keyup="keyupEvent">
                    </li> -->
          <!-- 현재 비밀번호 입력이 틀렸을 경우 -->
          <!-- <p class="txt-red" v-if="isCurrentPass">현재 비밀번호와 동일한 비밀번호는 사용할수 없습니다</p> -->

          <h4 class="bold mt-30">새 비밀번호</h4>
          <li>
            <input type="password" placeholder="새로운 비밀번호를 입력해 주세요." v-model="input.password" @keyup="keyupEvent" />
          </li>
          <p class="txt-red" v-if="isPass">영문+숫자+특수문자 8자리 이상으로 입력해 주세요.</p>

          <h4 class="bold mt-30">비밀번호 확인</h4>
          <li>
            <input type="password" placeholder="비밀번호를 한번 더 입력해주세요." v-model="input.passwordChk" @keyup="keyupEvent" />
          </li>
          <!-- 비밀번호가 제대로 입력되지 않았을 경우 -->
          <p class="txt-red" v-if="isPassChk">동일한 비밀번호를 입력해 주세요.</p>
        </ul>
      </div>
      <div class="bnb-btn">
        <!-- 비밀번호 입력 시 class="active" 활성화 -->
        <button :class="{ active: is_active }" @click="passwordTrans()">비밀번호 변경하기</button>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import { EmptyCheck, PWFormatCheck } from "@/utils/validation";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "password_trans",
  pros: {
    idx: {
      type: [Number, String],
      default: 0,
    },
    isAccount: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    input: {
      currentPassword: "",
      password: "",
      passwordChk: "",
    },
    is_active: false,
    isCurrentPass: false,
    isPass: false,
    isPassChk: false,
    userIdx: 0,
    isAccountText: 0,
    isLoadingPop: false,
  }),
  components: {
    incBack,
    Loading,
  },
  mounted() {
    let path = location.href;
    // console.log(path);
    let slug = path.split("/");
    console.log(slug);
    this.userIdx = Number(atob(slug[4]));
    this.isAccountText = Number(slug[5]);
    // alert(this.userIdx);
    // console.log(this.idx);
    // console.log(this.isAccount);
    // this.userIdx = Number(atob(this.idx));
    // alert(this.userIdx)
  },
  methods: {
    keyupEvent() {
      if (this.input.password != "" && this.input.passwordChk) {
        this.is_active = true;
      }
    },
    passwordTrans() {
      if (this.is_active) {
        if (!EmptyCheck(this.input.password, "비밀번호를") || !EmptyCheck(this.input.passwordChk, "비밀번호를")) {
          return false;
        }
        if (!PWFormatCheck(this.input.password)) {
          this.isPass = true;
          return false;
        } else {
          this.isPass = false;
        }
        if (this.input.currentPassword == this.input.password) {
          this.isCurrentPass = true;
          return false;
        } else {
          this.isPass = false;
        }
        if (this.input.password != this.input.passwordChk) {
          this.isPassChk = true;
          return false;
        } else {
          this.isPassChk = false;
        }
        let form = new FormData();
        form.append("userIdx", this.userIdx);
        form.append("UserPassword", this.input.password);
        this.axios
          .post("/front/user-pwupdate", form)
          .then((res) => {
            if (res.data.success) {
              alert("계정확인 및 비밀번호가 재설정 되었습니다. 다시 로그인해 주세요.");
              this.$router.push("/");
            } else {
              alert("비밀번호 변경의 실패하였습니다");
              return false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>
